// Módulo: CRUD de Lançamentos (Salvar, Editar, Excluir)
// Responsável por todas as operações de banco de dados e gerenciamento de estado de edição.

window.FazendaRP = window.FazendaRP || {};
window.FazendaRP.Pages = window.FazendaRP.Pages || {};
window.FazendaRP.Pages.financeiro = window.FazendaRP.Pages.financeiro || {};

Object.assign(window.FazendaRP.Pages.financeiro, {

    _pendingEditId: null, // Keep state here or in main scope

    salvarLancamento: async function (container) {
        if (this._isSaving) return;
        this._isSaving = true;
        try {
            let btn = container.querySelector('button[type="submit"]');
            if (!btn) btn = container.querySelector('.form-actions button.btn-primary'); // Fallback
            if (!btn) { console.error("Save button not found"); return; }

            const modoInput = container.querySelector('input[name="modo_lancamento"]:checked');
            const modo = modoInput ? modoInput.value : 'simples';

            // 1. Coleta de Dados Comuns
            const numDoc = container.querySelector('#num-documento').value;
            const tipoDoc = container.querySelector('#tipo-documento').value;
            const dataEmissao = container.querySelector('#data-emissao').value;

            const parceiroId = container.querySelector('#parceiro-select').value;
            const contaId = container.querySelector('#conta-banco').value;
            const condicao = container.querySelector('#condicao-pagamento').value;
            const checkPago = container.querySelector('#check-pagar-agora');
            const formaPag = container.querySelector('#forma-pagamento').value;
            const obs = container.querySelector('#obs-lancamento').value;

            // Enforce Account Selection for Credit Card
            if (formaPag === 'Cartão de Crédito' && !contaId) {
                window.FazendaRP.Toast.show('warning', 'Atenção', 'Selecione a Conta do Cartão de Crédito.');
                return;
            }



            // --- VALIDAÇÃO DE DUPLICIDADE (Documento + Parceiro) ---
            const formEl = container.querySelector('#form-lancamento');
            const currentEditId = window.FazendaRP.Pages.financeiro._editingId || (formEl ? formEl.dataset.editingId : null) || container.querySelector('#edit-lanc-id').value;

            if (numDoc && parceiroId) {
                const hiddenIdInput = container.querySelector('#edit-lanc-id');
                const originalStatus = hiddenIdInput && hiddenIdInput.dataset ? hiddenIdInput.dataset.originalStatus : null;

                if (originalStatus !== 'Pago') {
                    const { data: dups, error: dupErr } = await window.FazendaRP.supabase
                        .from('financeiro_lancamentos')
                        .select('id')
                        .eq('parceiro_id', parceiroId)
                        .neq('status', 'Cancelado')
                        .filter('detalhes->>num_doc', 'eq', numDoc);

                    if (dups && dups.length > 0) {
                        const realDups = dups.filter(d => !currentEditId || d.id != currentEditId);
                        if (realDups.length > 0) {
                            const conflictId = realDups[0].id;
                            const msg = `O documento ${numDoc} já existe no cadastro (ID: ${conflictId}). Você está editando o ID: ${currentEditId || 'Novo'}.`;
                            console.warn("Duplicidade REAL:", msg);
                            window.FazendaRP.Toast.show('error', 'Duplicidade', msg);
                            return;
                        }
                    }
                }
            }

            // Status Logic
            // Status Logic
            let status = 'Pendente';
            let dataPagamento = null;
            const isCartao = (formaPag === 'Cartão de Crédito');
            const isPagoCheck = (checkPago && checkPago.checked);

            if (condicao === 'vista') {
                if (isPagoCheck) {
                    status = 'Pago';
                    const inputDataReal = container.querySelector('#data-pagamento-real');
                    // Use custom date if filled, otherwise emission date
                    dataPagamento = (inputDataReal && inputDataReal.value) ? inputDataReal.value : dataEmissao;
                } else {
                    status = 'Pendente'; // Logic V5: Cartao Vista s/ Pag = Pendente
                }
            } else if (condicao === 'prazo') {
                status = 'Pendente'; // Default for batches, specific logic inside loop
            }

            // Coleta de Valores
            let totalLancamento = 0;
            let descricao = "";
            let categoria = "";
            let itens = [];
            let numParcelas = 1;

            if (modo === 'sem_itens') {
                let rawTotal = container.querySelector('#valor-total-sem-itens').value || '0';
                totalLancamento = parseFloat(rawTotal.replace(/[^\d,]/g, '').replace(',', '.')) || 0;
                descricao = container.querySelector('#desc-sem-itens').value;
                categoria = container.querySelector('#categoria-contabil').value; // Hidden Input

                // Fallback: Try to resolve category if user typed but didn't click
                if (!categoria) {
                    const catSearch = container.querySelector('#categoria-search');
                    if (catSearch && catSearch.value) {
                        const term = catSearch.value.trim();
                        // Try exact match in cache
                        const accounts = window.FazendaRP.Pages.financeiro.planoContasData || [];
                        const found = accounts.find(c => `${c.codigo} - ${c.nome}` === term || c.codigo === term || c.nome === term);
                        if (found) {
                            categoria = `${found.codigo}`;
                        }
                    }
                }

                if (!descricao) { window.FazendaRP.Toast.show('warning', 'Atenção', 'Preencha a Descrição.'); return; }
                if (!categoria) { window.FazendaRP.Toast.show('warning', 'Atenção', 'Selecione uma Categoria válida.'); return; }
            } else {
                const rows = container.querySelectorAll('.item-row');
                if (rows.length === 0) { window.FazendaRP.Toast.show('warning', 'Atenção', 'Adicione itens.'); return; }

                let validationError = null;

                rows.forEach(row => {
                    if (validationError) return;

                    const rawQtd = row.querySelector('.item-qtd').value || '0';
                    const qtd = parseFloat(rawQtd.replace(/\./g, '').replace(',', '.')) || 0;
                    const rawTotal = row.querySelector('.item-total').value || '0';
                    const total = parseFloat(rawTotal.replace(/[^\d,]/g, '').replace(',', '.')) || 0;
                    const nomeMat = row.querySelector('.item-material-search').value;

                    // Safe Access & Logs
                    const catEl = row.querySelector('.item-plano-select');
                    const catContabil = catEl ? catEl.value : '';

                    const maquinaEl = row.querySelector('.item-maquina-select');
                    const maquinaId = (maquinaEl && maquinaEl.value) ? maquinaEl.value : null;

                    const horEl = row.querySelector('.item-horimetro');
                    const horimetro = (horEl && horEl.value) ? horEl.value : null;

                    // New: Collect Unit Discount & Gross Unit Price
                    const descEl = row.querySelector('.item-desc');
                    let unitDiscount = 0;
                    if (descEl) {
                        const rawDesc = descEl.value.replace('R$', '').trim().replace(/\./g, '').replace(',', '.');
                        unitDiscount = parseFloat(rawDesc) || 0;
                    }

                    const vunitInput = row.querySelector('.item-vunit');
                    let grossUnit = 0;
                    if (vunitInput) {
                        const rawUnit = vunitInput.value.replace('R$', '').trim().replace(/\./g, '').replace(',', '.');
                        grossUnit = parseFloat(rawUnit) || 0;
                    }

                    if (total > 0 && nomeMat) {
                        totalLancamento += total;

                        // Resolver ID do Material pelo Nome (Busca Inteligente)
                        let itemId = null;
                        let suprimentoItemResolved = null;
                        if (window.FazendaRP.SuprimentosData && nomeMat) {
                            const term = nomeMat.trim().toUpperCase();
                            // 1. Exato Case Insensitive
                            suprimentoItemResolved = window.FazendaRP.SuprimentosData.find(s => s.nome.trim().toUpperCase() === term);

                            // 2. Parcial (Começa com) - Seguro se > 3 chars
                            if (!suprimentoItemResolved && term.length >= 3) {
                                suprimentoItemResolved = window.FazendaRP.SuprimentosData.find(s => s.nome.trim().toUpperCase().startsWith(term));
                            }

                            // 3. Parcial (Contém) - Fallback agressivo se > 4 chars (Ex: "Cipermetrina" acha "Brit (Cipermetrina)")
                            if (!suprimentoItemResolved && term.length >= 4) {
                                suprimentoItemResolved = window.FazendaRP.SuprimentosData.find(s => s.nome.trim().toUpperCase().includes(term));
                            }

                            if (suprimentoItemResolved) itemId = suprimentoItemResolved.id;
                        }

                        // --- RATEIO PER ITEM ---
                        let itemRateios = [];
                        if (catContabil.startsWith('1.1') || catContabil.startsWith('2.1')) {
                            // Find container (Sibling in .item-wrapper)
                            const wrapper = row.closest('.item-wrapper'); // Since we wrapped it
                            const rateioRows = wrapper ? wrapper.querySelectorAll('.item-rateio-row') : [];

                            let sumR = 0;
                            rateioRows.forEach(rr => {
                                const sSel = rr.querySelector('.safra-select');
                                const vInp = rr.querySelector('.safra-valor');
                                const sId = sSel ? parseInt(sSel.value) : null;
                                const val = vInp ? parseFloat(vInp.value.replace(/[^\d,]/g, '').replace(',', '.')) : 0;

                                if (sId && val > 0) {
                                    itemRateios.push({ safra_id: sId, valor: val });
                                    sumR += val;
                                }
                            });

                            // Validation
                            const diff = Math.abs(total - sumR);
                            if (diff > 0.1) { // 10 centavos tolerance
                                validationError = `O rateio do item '${nomeMat}' não bate com o total (Diferença: R$ ${diff.toFixed(2)}).`;
                            }
                            if (itemRateios.length === 0) {
                                validationError = `O item '${nomeMat}' exige rateio por safra (Conta Iniciada em 1.1 ou 2.1).`;
                            }
                        }

                        itens.push({
                            nome: nomeMat,
                            id: itemId,
                            unidade: (suprimentoItemResolved && suprimentoItemResolved.unidades) ? suprimentoItemResolved.unidades[0] : 'UN', // NEW: Persist Unit
                            qtd,
                            total,
                            valor_unitario: grossUnit, // Saved Explicitly!
                            desconto_unit: unitDiscount,
                            categoria: catContabil,
                            maquina_id: maquinaId,
                            horimetro: horimetro,
                            rateio: itemRateios
                        });
                    }
                });

                if (validationError) {
                    window.FazendaRP.Toast.show('error', 'Erro de Validação', validationError);
                    return;
                }

                // --- VALIDATION: Note Total vs Items Sum ---
                const totalNotaInput = container.querySelector('#valor-total-nota');
                if (totalNotaInput && totalNotaInput.value) {
                    const rawNota = totalNotaInput.value.replace(/[^\d,]/g, '').replace(',', '.');
                    const valNota = parseFloat(rawNota) || 0;

                    if (valNota > 0) {
                        const diff = Math.abs(valNota - totalLancamento);
                        if (diff > 0.05) { // 5 cents tolerance
                            window.FazendaRP.Toast.show('error', 'Valor Inconsistente',
                                `O valor da Nota (R$ ${valNota.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}) não bate com a soma dos itens (R$ ${totalLancamento.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}). Verifique descontos ou quantidades.`);
                            return;
                        }
                    }
                }

                if (itens.length === 0) { window.FazendaRP.Toast.show('warning', 'Atenção', 'Itens inválidos.'); return; }

                // ✅ NORMALIZE FUEL NAMES BEFORE SAVING
                // This ensures the financial entry stores the same normalized names as stock movements
                itens.forEach(item => {
                    const catItem = (item.categoria || categoria || '').toUpperCase();
                    const isFuelCategory = catItem.includes('DIESEL') || catItem.includes('GASOLINA') || catItem.includes('ETANOL');

                    if (isFuelCategory) {
                        const searchStr = (catItem + ' ' + (item.nome || '').toUpperCase());
                        let itemNomeNormalizado = item.nome;
                        let unidadeNormalizada = item.unidade || 'UN';

                        if (searchStr.includes('ETANOL')) {
                            itemNomeNormalizado = 'Etanol';
                            unidadeNormalizada = 'L';
                        } else if (searchStr.includes('GASOLINA ADITIVADA')) {
                            itemNomeNormalizado = 'Gasolina Aditivada';
                            unidadeNormalizada = 'L';
                        } else if (searchStr.includes('GASOLINA')) {
                            itemNomeNormalizado = 'Gasolina';
                            unidadeNormalizada = 'L';
                        } else if (searchStr.includes('ARLA')) {
                            itemNomeNormalizado = 'Arla 32';
                            unidadeNormalizada = 'L';
                        } else if (searchStr.includes('S10')) {
                            itemNomeNormalizado = 'Diesel S10';
                            unidadeNormalizada = 'L';
                        } else if (searchStr.includes('S500')) {
                            itemNomeNormalizado = 'Diesel S500';
                            unidadeNormalizada = 'L';
                        } else if (searchStr.includes('DIESEL')) {
                            itemNomeNormalizado = 'Oleo Diesel';
                            unidadeNormalizada = 'L';
                        }

                        if (item.nome !== itemNomeNormalizado) {
                            console.log(`[FUEL NORMALIZE PRE-SAVE] "${item.nome}" → "${itemNomeNormalizado}"`);
                            item.nome = itemNomeNormalizado;
                            item.unidade = unidadeNormalizada;
                        }
                    }
                });

                descricao = `NF ${numDoc} - ${itens.length} itens`;
                categoria = itens[0].categoria;
            }

            // --- RATEIO SAFRAS (Global / Sem Itens or Legacy) ---
            const rateios = [];
            const rowsRateio = container.querySelectorAll('.rateio-row, .rateio-row-global');
            let sumRateioGlobal = 0;

            if (rowsRateio.length > 0) {
                rowsRateio.forEach(r => {
                    const selectSafra = r.querySelector('select'); // Works for both
                    const safraId = selectSafra ? selectSafra.value : null;

                    // Support both old class .rateio-valor and new .safra-valor
                    const inpVal = r.querySelector('.rateio-valor, .safra-valor');
                    const valR = inpVal ? parseFloat(inpVal.value.replace(/[^\d,]/g, '').replace(',', '.')) : 0;

                    if (safraId && valR > 0) {
                        rateios.push({ safra_id: parseInt(safraId), talhao_id: null, valor: valR });
                        sumRateioGlobal += valR;
                    }
                });
            }

            // Validation for Sem Itens Rateio
            if (modo === 'sem_itens' && (categoria.startsWith('1.1') || categoria.startsWith('2.1'))) {
                if (rateios.length === 0) {
                    window.FazendaRP.Toast.show('warning', 'Atenção', 'Esta categoria exige Rateio por Safra.'); return;
                }
                const diff = Math.abs(totalLancamento - sumRateioGlobal);
                if (diff > 0.10) {
                    window.FazendaRP.Toast.show('warning', 'Atenção', `O valor do rateio (R$ ${sumRateioGlobal.toFixed(2)}) não bate com o total (R$ ${totalLancamento.toFixed(2)}).`); return;
                }
            }

            // --- MACHINE COST COLLECTION (Simple Mode) ---
            const custoMaquinas = [];
            const areaMaquinas = container.querySelector('#area-rateio-maquinas .rateio-maquinas-rows-area');
            if (modo === 'sem_itens' && areaMaquinas) {
                areaMaquinas.querySelectorAll('.rateio-maquina-row').forEach(row => {
                    const sel = row.querySelector('.maquina-select');
                    const valInp = row.querySelector('.maquina-valor');
                    const mId = sel ? sel.value : null;
                    const val = valInp ? parseFloat(valInp.value.replace(/[^\d,]/g, '').replace(',', '.')) : 0;
                    const litrosInp = row.querySelector('.maquina-litros');
                    const litros = litrosInp ? parseFloat(litrosInp.value) : 0;
                    const horInp = row.querySelector('.maquina-horimetro');
                    const horimetro = horInp ? horInp.value : null;

                    if (mId && val > 0) {
                        custoMaquinas.push({ maquina_id: parseInt(mId), valor: val, litros: litros, horimetro: horimetro });
                    }
                });
            }

            if (totalLancamento <= 0) { window.FazendaRP.Toast.show('warning', 'Atenção', 'Valor total inválido.'); return; }
            if (!parceiroId) { window.FazendaRP.Toast.show('warning', 'Atenção', 'Selecione um Parceiro.'); return; }

            // ✅ VALIDATION: Require document number for NF (Nota Fiscal)
            if (tipoDoc === 'NF' && (!numDoc || numDoc.trim() === '')) {
                window.FazendaRP.Toast.show('warning', 'Número da NF Obrigatório', 'Por favor, informe o número da Nota Fiscal.');
                return;
            }

            // --- ATTACHMENTS HANDLING (Including Auto-XML) ---
            let finalAnexos = window.FazendaRP.Pages.financeiro.currentAttachments || [];

            // Check for Auto-Imported XML
            if (window.FazendaRP.TempXMLFile) {
                const xmlFile = window.FazendaRP.TempXMLFile;
                console.log("Financeiro: Uploading auto-attached XML...", xmlFile.name);

                const fileName = `${Date.now()}_${xmlFile.name}`;
                const { data: upData, error: upErr } = await window.FazendaRP.supabase
                    .storage
                    .from('comprovantes')
                    .upload(fileName, xmlFile);

                if (upErr) {
                    console.error("Financeiro: XML Auto-Upload Failed:", upErr);
                    window.FazendaRP.Toast.show('warning', 'Aviso', 'Falha ao anexar XML automaticamente. Erro no upload.');
                } else {
                    const { data: pubUrl } = window.FazendaRP.supabase
                        .storage
                        .from('comprovantes')
                        .getPublicUrl(fileName);

                    finalAnexos.push({
                        name: xmlFile.name,
                        path: fileName,
                        url: pubUrl.publicUrl,
                        type: 'text/xml'
                    });

                    // Clear Temp File to avoid re-uploading on next save
                    window.FazendaRP.TempXMLFile = null;
                }
            }

            // --- PREPARE PAYLOADS ---
            const payloads = [];

            if (condicao === 'prazo' && !currentEditId) {
                const rowParcelas = container.querySelectorAll('#tabela-parcelas tbody tr');
                if (rowParcelas.length === 0) { window.FazendaRP.Toast.show('warning', 'Atenção', 'Gere as parcelas na tabela.'); return; }
                numParcelas = rowParcelas.length;

                // Create Array of Parcelas
                const parcelasData = [];
                rowParcelas.forEach((tr, idx) => {
                    const inputs = tr.querySelectorAll('input');
                    const dtVenc = inputs[0].value;
                    const valStr = inputs[1].value;
                    const valP = parseFloat(valStr.replace(/[^\d,]/g, '').replace(',', '.')) || 0;

                    let parcStatus = status; // 'Pendente' or 'Pago' based on header logic (Wait, logic V5 says Vista=Pago/Pend, Prazo=Pendente)
                    let parcDtPag = null;

                    // If Credit Card and "Pagar Agora" is checked on header? 
                    // Usually "Pagar Agora" is hidden for Prazo?
                    // Let's check logic: if condicao === 'prazo', status usually 'Pendente'.
                    // EXCEPT Credit Card: 1st might be Paid? 
                    // Current logic lines 88: else if (condicao === 'prazo') status = 'Pendente'.
                    // So default is Pendente. The special "1st Paid" logic was inside the loop. Let's restore it.

                    if (isCartao && condicao === 'prazo') {
                        if (isPagoCheck) {
                            if (idx === 0) {
                                parcStatus = 'Pago';
                                parcDtPag = dataEmissao;
                            } else {
                                parcStatus = 'Agendado';
                            }
                        } else {
                            parcStatus = 'Pendente';
                        }
                    }

                    parcelasData.push({
                        parcela: idx + 1,
                        data_vencimento: dtVenc,
                        valor: valP,
                        status: parcStatus,
                        data_pagamento: parcDtPag
                    });
                });

                // Single Payload
                payloads.push({
                    tipo: 'Despesa',
                    descricao: `${descricao} (Parcelado ${numParcelas}x)`,
                    num_doc: numDoc || null,
                    valor: totalLancamento, // Total Value of Transaction
                    valor_documento: totalLancamento, // Valor Original da NF (Imutável)
                    data_vencimento: parcelasData[0].data_vencimento, // Use 1st as reference
                    data_emissao: dataEmissao || null,
                    data_pagamento: null, // Header payment date? ambiguous. Leave null or 1st?
                    status: 'Pendente', // Header status usually Pendente for Installments
                    categoria: categoria,
                    parceiro_id: parseInt(parceiroId),
                    conta_id: contaId ? parseInt(contaId) : null,
                    anexos: finalAnexos,
                    detalhes: {
                        tipo_doc: tipoDoc,
                        num_doc: numDoc,
                        chave_nfe: container.querySelector('#chave-nfe-hidden')?.value || null, // NEW: Persist NFe Key
                        modo: modo,
                        condicao: condicao, // 'prazo'
                        forma_pagamento: formaPag,
                        total_parcelas: numParcelas,
                        parcelas: parcelasData, // NEW ARRAY
                        itens: itens,
                        rateio: rateios,
                        custo_maquinas: custoMaquinas,
                        obs: obs
                    }
                });

            } else {
                // Single (Vista or Edit Mode)
                payloads.push({
                    tipo: 'Despesa',
                    descricao: descricao,
                    num_doc: numDoc || null,
                    valor: totalLancamento,
                    valor_documento: totalLancamento, // Valor Original da NF (Imutável)
                    data_vencimento: container.querySelector('#data-vencimento').value,
                    data_emissao: dataEmissao || null,
                    data_pagamento: dataPagamento,
                    status: status,
                    categoria: categoria,
                    parceiro_id: parseInt(parceiroId),
                    conta_id: contaId ? parseInt(contaId) : null,
                    anexos: finalAnexos,
                    detalhes: {
                        tipo_doc: tipoDoc,
                        num_doc: numDoc,
                        chave_nfe: container.querySelector('#chave-nfe-hidden')?.value || null, // NEW: Persist NFe Key
                        modo: modo,
                        condicao: condicao,
                        forma_pagamento: formaPag,
                        itens: itens,
                        rateio: rateios,
                        custo_maquinas: custoMaquinas,
                        obs: obs
                    }
                });
            }

            // --- MODO RESTRITO (PAGO) ---
            const hiddenIdInput2 = container.querySelector('#edit-lanc-id');
            const originalStatus2 = hiddenIdInput2 ? hiddenIdInput2.dataset.originalStatus : null;

            // --- MODO RESTRITO (GLOBAL) ---
            // User Request: "Todos devem ser bloqueados"
            // We now treat ALL edits as restricted updates (Obs/Anexos only).
            if (currentEditId) {
                const safePayload = {
                    anexos: (this.currentAttachments || []),
                    detalhes: payloads[0].detalhes
                };
                btn.disabled = true; btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Salvando (Restrito)...';
                const { error } = await window.FazendaRP.supabase
                    .from('financeiro_lancamentos')
                    .update(safePayload)
                    .eq('id', currentEditId);

                if (error) {
                    window.FazendaRP.Toast.show('error', 'Erro', error.message);
                    btn.disabled = false; btn.innerHTML = 'Salvar (Obs/Anexos)';
                } else {
                    window.FazendaRP.Toast.show('success', 'Sucesso', 'Observações e Anexos atualizados!');
                    this.renderTabContent('lancamentos');
                    this.renderListaLancamentos(container);
                }
                return;
            }

            // --- SAVE ---
            btn.disabled = true; btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Salvando...';
            let errorCount = 0;
            let insertedData = null;

            if (currentEditId) {
                const p = payloads[0];
                const { error } = await window.FazendaRP.supabase.from('financeiro_lancamentos').update(p).eq('id', currentEditId);
                if (error) {
                    errorCount++;
                } else {
                    insertedData = [{ id: currentEditId, ...p }];
                    // Update Logic for Movements (Complexity: Refactor requires Handling Edit of Parcelado)
                    // For now, let's assume Edit operates on the Single Document. 
                    // Updating movements for edited installment is tricky.
                    // Ideally: Fetch existing movements, diff, and update.
                    // For this task (Focus on New Creation "One Document"), we'll leave Edit mostly as is (it updates the Header).
                    // BUT if we change Parcel Info during Edit... that's a bigger scope. 
                    // Let's ensure New Insertions work first.  

                    // Specific Fix for "Pago" Update (Legacy/Single)
                    if (status === 'Pago' && !p.detalhes.parcelas) {
                        const contaIdSafe = p.conta_id;
                        if (p.valor > 0 && contaIdSafe) {
                            // ... existing logic for converting single pending to paid ...
                            const movPayload = {
                                lancamento_id: currentEditId,
                                conta_id: parseInt(contaIdSafe),
                                data_operacao: p.data_pagamento || p.data_emissao || new Date().toISOString().split('T')[0],
                                valor: p.valor,
                                tipo: (p.tipo === 'Receita') ? 'CREDITO' : 'DEBITO',
                                historico: `Ref. ${p.descricao || 'Lançamento Financeiro'}`,
                                status: 'Efetivado'
                            };

                            const { data: existingMov } = await window.FazendaRP.supabase
                                .from('financeiro_movimentacoes')
                                .select('id')
                                .eq('lancamento_id', currentEditId)
                                .maybeSingle();

                            if (!existingMov) {
                                await window.FazendaRP.supabase.from('financeiro_movimentacoes').insert([movPayload]);
                            }
                        }
                    }
                }
            } else {
                // INSERT - Capture Data for Receipt
                const { data: insData, error } = await window.FazendaRP.supabase
                    .from('financeiro_lancamentos')
                    .insert(payloads)
                    .select();

                insertedData = insData;

                if (error) {
                    errorCount++;
                    console.error("DEBUG: Lancamento Insert Failed:", error);
                } else if (insertedData && insertedData.length > 0) {
                    const lanc = insertedData[0]; // We assume single insert now
                    const contaIdSafe = lanc.conta_id;

                    // --- GENERATE MOVEMENTS (Future & Present) ---
                    // Strategy: Always generate movements if we have valid info.
                    // For Single: If 'Pago', gen 'Efetivado'. If 'Agendado' (future card?), gen 'Agendado'.
                    // For Parcelado: Iterate details.parcelas and gen 'Agendado'/'Efetivado'.

                    const detalhes = lanc.detalhes || {};
                    const tipoMov = (lanc.tipo === 'Receita') ? 'CREDITO' : 'DEBITO';

                    if (detalhes.parcelas && Array.isArray(detalhes.parcelas) && detalhes.parcelas.length > 0) {
                        // PARCELADO LOGIC
                        // Only create movements for installments that are ALREADY PAID (e.g. Entrada w/ "Pagar Agora")
                        // Future installments ('Agendado'/'Pendente') stay only in DETALHES and show in Agenda.
                        // They do NOT go to 'financeiro_movimentacoes' until executed.

                        const movsToInsert = [];
                        console.log("DEBUG: Processing Parcelas for Movement Creation", detalhes.parcelas);

                        detalhes.parcelas.forEach(p => {
                            // STRICT CHECK: Only 'Pago' status triggers movement
                            if (p.valor > 0 && contaIdSafe && p.status === 'Pago') {
                                console.log("DEBUG: Creating Movement for Paid Installment", p);
                                movsToInsert.push({
                                    lancamento_id: lanc.id,
                                    conta_id: parseInt(contaIdSafe),
                                    data_operacao: p.data_pagamento || lanc.data_emissao, // Use payment date
                                    valor: p.valor,
                                    tipo: tipoMov,
                                    historico: `Ref. ${lanc.descricao} - Parc ${p.parcela}/${detalhes.total_parcelas}`,
                                    status: 'Efetivado'
                                });
                            } else {
                                console.log("DEBUG: Skipping Movement for Future/Unpaid Installment", p.status, p);
                            }
                        });


                        if (movsToInsert.length > 0) {
                            console.log("DEBUG: Inserting Movements", movsToInsert);
                            const { error: movErr } = await window.FazendaRP.supabase
                                .from('financeiro_movimentacoes')
                                .insert(movsToInsert);
                            if (movErr) console.error("Failed to insert initial paid movements", movErr);
                        } else {
                            console.log("DEBUG: No Movements to Insert (All installments are future/unpaid)");
                        }
                    } else {
                        // SINGLE LOGIC (Old Behavior)
                        if (contaIdSafe && lanc.valor > 0) {
                            // Only if 'Pago' or we want to project 'Agendado' for single too?
                            // Standard behavior: 'Pago' -> Movement. 'Pendente' -> No Movement.
                            // But for Credit Card?
                            // If isCreditCard, currently we have status 'Pendente' or 'Pago'.
                            // If 'Pago', it goes to invoice.
                            // If 'Agendado' (Credit Card Scheduled?), goes to invoice.
                            // Let's stick to: If 'Pago', create 'Efetivado'.

                            // Edit: User wants "Ao agendar... deve ir movimentações".
                            // So if specific date is set and confirmed?
                            // Use standard logic: 
                            if (lanc.status === 'Pago') {
                                const movPayload = {
                                    lancamento_id: lanc.id,
                                    conta_id: parseInt(contaIdSafe),
                                    data_operacao: lanc.data_pagamento || lanc.data_emissao || new Date().toISOString().split('T')[0],
                                    valor: lanc.valor,
                                    tipo: tipoMov,
                                    historico: `Ref. ${lanc.descricao || 'Lançamento Financeiro'}`,
                                    status: 'Efetivado'
                                };
                                await window.FazendaRP.supabase.from('financeiro_movimentacoes').insert([movPayload]);
                            }
                        }
                    }


                    // --- STOCK INTEGRATION (EXIT/CONSUMPTION) ---
                    // MOVED: Logic moved to after "ENTRADA" to prevent "Item nonexistent" errors.

                }
            }

            if (errorCount > 0) {
                window.FazendaRP.Toast.show('error', 'Erro', 'Falha ao salvar lançamentos.');
                btn.disabled = false; btn.innerText = "Salvar";
            } else {
                window.FazendaRP.Toast.show('success', 'Sucesso', 'Lançamento(s) salvo(s)!');

                // Maquinas Integration
                if (modo === 'com_itens' && itens.length > 0) {
                    for (const item of itens) {
                        try {
                            const nome = item.nome.toUpperCase();

                            // 1. INTEGRACAO MAQUINAS (ABASTECIMENTO)
                            // 1. INTEGRACAO MAQUINAS (ABASTECIMENTO) - POR PLANO DE CONTAS (User Request #182)
                            let fuelProcessed = false;

                            // Determine Category (Item specific or Global)
                            const catItem = (item.categoria || categoria || '').toUpperCase();

                            // Check Valid Fuel Categories (Diesel, Gasolina, Etanol)
                            // "Óleo Diesel", "Diesel S10", "Gasolina", "Gasolina Aditivada", "Etanol"
                            const isFuelCategory = catItem.includes('DIESEL') || catItem.includes('GASOLINA') || catItem.includes('ETANOL');

                            if (item.maquina_id && isFuelCategory && window.FazendaRP.Pages.maquinas && window.FazendaRP.Pages.maquinas.registrarAbastecimento) {
                                console.log(`[Integration] Triggering Abastecimento based on Account: ${catItem}`);

                                // Determine Fuel Type using both Category and Item Name
                                const searchStr = (catItem + ' ' + (item.nome || '').toUpperCase());

                                let fuelType = item.nome || 'Diesel'; // Default to Item Name
                                if (searchStr.includes('ETANOL')) fuelType = 'Etanol';
                                else if (searchStr.includes('GASOLINA ADITIVADA')) fuelType = 'Gasolina Aditivada';
                                else if (searchStr.includes('GASOLINA')) fuelType = 'Gasolina';
                                else if (searchStr.includes('ARLA')) fuelType = 'Arla 32';
                                else if (searchStr.includes('S10')) fuelType = 'Diesel S10';
                                else if (searchStr.includes('S500')) fuelType = 'Diesel S500';
                                else if (searchStr.includes('DIESEL')) fuelType = 'Oleo Diesel';


                                window.FazendaRP.Pages.maquinas.registrarAbastecimento({
                                    maquinaId: item.maquina_id,
                                    data: dataEmissao || new Date().toISOString().split('T')[0],
                                    litros: item.qtd,
                                    valorTotal: item.total,
                                    horimetro: item.horimetro || null,
                                    observacao: `Gerado via Financeiro (NF ${numDoc}) - ${item.nome}`,
                                    lancamentoId: (insertedData && insertedData.length > 0) ? insertedData[0].id : null,
                                    tipoCombustivel: fuelType, // CORRECTED PROPERTY NAME (matches maquinas_new.js)
                                    baixarEstoque: false // IMPORTANT: Finance already handles stock exit. Don't dup.
                                }).then(res => {
                                    if (res) {
                                        console.log("Integração SUCESSO:", res);
                                        fuelProcessed = true;
                                        window.FazendaRP.Toast.show('success', 'Integração', `Abastecimento (${fuelType}) registrado.`);
                                    }
                                }).catch(err => {
                                    console.error("Erro na Integração:", err);
                                });

                            } else {
                                if (item.maquina_id) console.log(`[Integration] Skipped Fuel: Category '${catItem}' is not a fuel account.`);
                            }

                            // 2. INTEGRACAO ESTOQUE (ENTRADA) - NOVO!
                            const catStr = (categoria || '').toUpperCase();
                            const isServico = catStr.includes('SERVIÇ') || catStr.includes('MÃO DE OBRA') || catStr.includes('HONORÁRIO');

                            if (!isServico) {
                                // ✅ NORMALIZE FUEL NAMES (Title Case)
                                let itemNomeNormalizado = item.nome;
                                let unidadeNormalizada = item.unidade || 'UN';

                                if (isFuelCategory) {
                                    const searchStr = (catItem + ' ' + (item.nome || '').toUpperCase());

                                    if (searchStr.includes('ETANOL')) {
                                        itemNomeNormalizado = 'Etanol';
                                        unidadeNormalizada = 'L';
                                    } else if (searchStr.includes('GASOLINA ADITIVADA')) {
                                        itemNomeNormalizado = 'Gasolina Aditivada';
                                        unidadeNormalizada = 'L';
                                    } else if (searchStr.includes('GASOLINA')) {
                                        itemNomeNormalizado = 'Gasolina';
                                        unidadeNormalizada = 'L';
                                    } else if (searchStr.includes('ARLA')) {
                                        itemNomeNormalizado = 'Arla 32';
                                        unidadeNormalizada = 'L';
                                    } else if (searchStr.includes('S10')) {
                                        itemNomeNormalizado = 'Diesel S10';
                                        unidadeNormalizada = 'L';
                                    } else if (searchStr.includes('S500')) {
                                        itemNomeNormalizado = 'Diesel S500';
                                        unidadeNormalizada = 'L';
                                    } else if (searchStr.includes('DIESEL')) {
                                        itemNomeNormalizado = 'Oleo Diesel';
                                        unidadeNormalizada = 'L';
                                    }

                                    console.log(`[FUEL NORMALIZE] "${item.nome}" → "${itemNomeNormalizado}"`);
                                }

                                console.log("Integrando Estoque (Item Material):", itemNomeNormalizado);

                                // Debug: verificar custo
                                // Ensure valid numeric parsing (handling strings/numbers)
                                const safeNum = (v) => {
                                    if (typeof v === 'number') return v;
                                    if (!v) return 0;
                                    if (typeof v === 'string') {
                                        // Remove currency symbols and spaces
                                        let clean = v.replace('R$', '').trim();
                                        // Strip everything that is NOT digit, comma, dot, or minus
                                        clean = clean.replace(/[^\d.,-]/g, '');

                                        // Handle PT-BR format (1.234,56)
                                        if (clean.includes(',') && clean.includes('.')) {
                                            // 1.234,56 -> 1234.56
                                            clean = clean.replace(/\./g, '').replace(',', '.');
                                        } else if (clean.includes(',')) {
                                            // 1234,56 -> 1234.56
                                            clean = clean.replace(',', '.');
                                        }
                                        return parseFloat(clean) || 0;
                                    }
                                    return 0;
                                };

                                const rawUnit = item.valor_unitario || item.valorUnitario;
                                const rawTotal = item.total || item.valorTotal;
                                const rawQtd = item.qtd || item.quantidade;

                                let custoUnit = safeNum(rawUnit);

                                // Fallback: Calculate from Total/Qtd if Unit is missing/zero
                                if (custoUnit === 0 && safeNum(rawTotal) > 0 && safeNum(rawQtd) > 0) {
                                    custoUnit = safeNum(rawTotal) / safeNum(rawQtd);
                                }

                                console.log(`💰 [DEBUG_COST_V2] Processing Item: ${itemNomeNormalizado}`);
                                console.log(`   rawUnit: ${rawUnit} (${typeof rawUnit})`);
                                console.log(`   Final custoUnit: ${custoUnit}`);

                                if (custoUnit === 0) {
                                    alert(`Atenção: O item '${itemNomeNormalizado}' está sendo salvo com Custo Unitário ZERO! Verifique o valor.`);
                                }

                                await window.FazendaRP.Estoque.registrarMovimentacao({
                                    itemNome: itemNomeNormalizado,
                                    itemId: item.id,
                                    tipo: 'ENTRADA',
                                    quantidade: safeNum(rawQtd),
                                    custoUnitario: custoUnit,
                                    origemTipo: 'COMPRA',
                                    origemId: (insertedData && insertedData.length > 0) ? insertedData[0].id : null,
                                    observacao: `Compra NF ${numDoc} - ${parceiroId ? document.querySelector('#parceiro-select option[value="' + parceiroId + '"]')?.text : ''}`,
                                    unidade: unidadeNormalizada,
                                    dataOperacao: dataEmissao || new Date().toISOString().split('T')[0]
                                });

                                // 3. SAIDA IMEDIATA (Se tiver máquina vinculada)
                                // Executa DEPOIS da entrada para garantir saldo.
                                // FIX: Database-driven fuel detection using 'contas' field

                                // Helper: Check if item is a fuel by verifying its category hierarchy
                                // Fuels are items under "Combustível" category or its subcategories
                                const isFuelItem = (itemId) => {
                                    if (!itemId || !window.FazendaRP.SuprimentosData) {
                                        return false;
                                    }

                                    const dbItem = window.FazendaRP.SuprimentosData.find(s => s.id === itemId);
                                    if (!dbItem) {
                                        return false;
                                    }

                                    // Helper to check if a category is fuel-related
                                    const isFuelCategory = (categoryId, visited = new Set()) => {
                                        if (!categoryId || visited.has(categoryId)) return false;
                                        visited.add(categoryId);

                                        const category = window.FazendaRP.SuprimentosData.find(s => s.id === categoryId);
                                        if (!category) return false;

                                        // Check if category name contains fuel keywords
                                        const catName = category.nome.toUpperCase();
                                        if (catName.includes('COMBUSTÍVEL') ||
                                            catName.includes('DIESEL') ||
                                            catName.includes('GASOLINA') ||
                                            catName.includes('ETANOL')) {
                                            return true;
                                        }

                                        // Recursively check parent category
                                        if (category.parent_id) {
                                            return isFuelCategory(category.parent_id, visited);
                                        }

                                        return false;
                                    };

                                    // Check if item belongs to a fuel category
                                    const isFuel = dbItem.parent_id ? isFuelCategory(dbItem.parent_id) : false;

                                    console.log(`[isFuelItem] Item "${dbItem.nome}": ${isFuel ? '✅ FUEL' : '❌ NOT FUEL'} (parent_id: ${dbItem.parent_id || 'none'})`);

                                    return isFuel;
                                };

                                // Only create manual stock out if:
                                // 1. Has machine linked
                                // 2. Not already processed as fuel (fuelProcessed) -> Wait, fuelProcessed is true if we sent to maquinas.
                                // BUT we passed baixarEstoque: false to maquinas. So we MUST process stock here.
                                // So we ignore fuelProcessed check? No, fuelProcessed just meant we sent API call.
                                // We WANT to create stock movement here.

                                // REVISED LOGIC: Always perform SAIDA if machine linked, regardless if it's fuel or not.
                                // Because we disabled stock deduction in maquinas integration.
                                if (item.maquina_id) {
                                    await window.FazendaRP.Estoque.registrarMovimentacao({
                                        itemNome: itemNomeNormalizado, // ✅ FIX: Use normalized name (matches Entry logic)
                                        itemId: item.id,
                                        tipo: 'SAIDA',
                                        quantidade: parseFloat(item.qtd) || 0,
                                        custoUnitario: 0,
                                        origemTipo: 'APLICACAO',
                                        origemId: (insertedData && insertedData.length > 0) ? insertedData[0].id : null,
                                        observacao: `Aplicação Imediata na Máquina (Via NF ${numDoc})`,
                                        unidade: item.unidade || 'UN',
                                        dataOperacao: dataEmissao || new Date().toISOString().split('T')[0]
                                    });
                                }
                            }

                        } catch (e) { console.error("Erro Integracao:", e); }
                    }
                }

                // --- INBOX BOT APPROVAL LINKING ---
                const formEl = container.querySelector('#form-lancamento');
                const preLaunchId = (formEl ? formEl.dataset.preLancamentoId : null) || (container.querySelector('#pre-lancamento-id')?.value);

                if (preLaunchId) {
                    console.log(`Approving Pre-Launch ID: ${preLaunchId}`);
                    // Async Update (Don't await to block UI)
                    const newId = (insertedData && insertedData.length > 0) ? insertedData[0].id : null;
                    window.FazendaRP.supabase
                        .from('financeiro_pre_lancamentos')
                        .update({
                            status: 'aprovado',
                            lancamento_gerado_id: newId
                        })
                        .eq('id', preLaunchId)
                        .then(({ error }) => {
                            if (error) console.error("Error updating pre-launch status:", error);
                            else console.log("Pre-Launch marked as approved.");
                        });
                }

                this.renderTabContent('lancamentos');
                document.querySelectorAll('.submenu-item').forEach(t => t.classList.remove('active'));
                document.querySelector('.submenu-item[data-tab="lancamentos"]')?.classList.add('active');
            }
        } catch (e) {
            console.error("CRITICAL ERROR in salvarLancamento:", e);
            window.FazendaRP.Toast.show('error', 'Erro Interno', 'Falha ao processar: ' + e.message);
            const btn = container.querySelector('button[type="submit"]') || container.querySelector('.btn-primary');
            if (btn) { btn.disabled = false; btn.innerHTML = "Salvar Lançamento"; }
        } finally {
            this._isSaving = false;
        }
    },

    atualizarLancamento: function (container, id) {
        // Alias for compatibility if needed, or redirect logic. 
        // Logic is merged in salvarLancamento via currentEditId check mostly, 
        // but 'atualizarLancamento' in original file had specific logic.
        // For simplicity in refactor, we should map the button onclick to calling salvarLancamento
        // OR implement explicit update logic here if different.
        // Original code had a separate function, let's keep it to avoid breakage.
        // Actually, looking at original code, 'atualizarLancamento' handles the Edit form submission specifically.
        return this.salvarLancamento(container);
    },


    loadLancamentoForEdit: async function (id, options = {}) {
        const isReadOnly = options.readOnly || false;

        // SAFE SWITCH: Don't call renderTabContent recursively.
        // 1. Activate Tab UI manually
        document.querySelectorAll('.submenu-item').forEach(t => t.classList.remove('active'));
        const tabNovo = document.querySelector('.submenu-item[data-tab="novo-lancamento"]');
        if (tabNovo) tabNovo.classList.add('active');

        // 2. Set Context ID (Critical)
        if (window.FazendaRP.Pages.financeiro) {
            window.FazendaRP.Pages.financeiro._pendingEditId = id;
        }

        let container = document.getElementById('financeiro-content');
        let form = document.getElementById('form-lancamento');

        // 3. Render Form ONLY if missing
        if (!form) {
            // Force render just the form module, not the whole tab controller
            if (this.renderFormularioLancamento) {
                await this.renderFormularioLancamento(container);
            } else if (window.FazendaRP.Pages.financeiro.renderFormularioLancamento) {
                await window.FazendaRP.Pages.financeiro.renderFormularioLancamento(container);
            }
            form = document.getElementById('form-lancamento');
        }
        if (!form) return;

        // Update Valid Page Title (Menu Header)
        const pageTitle = document.getElementById('financeiro-page-title');
        if (pageTitle) pageTitle.innerText = isReadOnly ? "Detalhes do Lançamento" : "Editar Lançamento";

        // Update Internal Content Title (H3)
        const contentHeader = container.querySelector('h3');
        if (contentHeader && contentHeader.innerText.includes('Novo Lançamento')) {
            contentHeader.innerText = isReadOnly ? "Visualizar Lançamento" : "Editar Lançamento";
        }

        // --- READ ONLY MODE TOGGLE ---
        const btnSalvar = document.getElementById('btn-salvar-lancamento');
        const btnAddItem = document.getElementById('btn-add-item');

        if (isReadOnly) {
            form.classList.add('read-only-mode');
            form.querySelectorAll('input, select, textarea').forEach(el => el.disabled = true);
            if (btnSalvar) btnSalvar.style.display = 'none';
            if (btnAddItem) btnAddItem.style.display = 'none';

            // Hide Buttons via Style
            const style = document.createElement('style');
            style.id = 'style-read-only-overrides';
            style.innerHTML = `
                .read-only-mode .btn-remove-item, 
                .read-only-mode .btn-remove-anexo, 
                .read-only-mode .btn-quick-add-item,
                .read-only-mode .rateio-remove-btn,
                #form-lancamento.read-only-mode #btn-salvar-lancamento { display: none !important; }
            `;
            document.head.appendChild(style);
        } else {
            form.classList.remove('read-only-mode');
            form.querySelectorAll('input, select, textarea').forEach(el => el.disabled = false);
            if (btnSalvar) btnSalvar.style.display = 'block';
            if (btnAddItem) btnAddItem.style.display = 'block';
            const existingStyle = document.getElementById('style-read-only-overrides');
            if (existingStyle) existingStyle.remove();
        }

        // 2. Buscar Dados Completos (FIXED QUERY)
        const { data: lanc, error } = await window.FazendaRP.supabase
            .from('financeiro_lancamentos')
            .select('*, parceiros(nome)')
            .eq('id', id)
            .single();

        if (error || !lanc) {
            window.FazendaRP.Toast.show('error', 'Erro', 'Não foi possível carregar o lançamento.');
            return;
        }

        if (!lanc.detalhes && !lanc.descricao) {
            window.FazendaRP.Toast.show('warning', 'Aviso', 'Este lançamento parece vazio ou incompleto.');
        }

        // Ensure JSON parsing
        if (lanc.detalhes && typeof lanc.detalhes === 'string') {
            try { lanc.detalhes = JSON.parse(lanc.detalhes); } catch (e) { console.error("Erro parse detalhes:", e); }
        }
        if (lanc.anexos && typeof lanc.anexos === 'string') {
            try { lanc.anexos = JSON.parse(lanc.anexos); } catch (e) { console.error("Erro parse anexos:", e); }
        }

        const strId = String(lanc.id);
        window.FazendaRP.Pages.financeiro._editingId = strId;
        if (form) form.dataset.editingId = strId;

        if (document.getElementById('edit-lanc-id')) {
            document.getElementById('edit-lanc-id').value = lanc.id;
            document.getElementById('edit-lanc-id').dataset.originalStatus = lanc.status || 'Pendente';
        }

        // 4. Preencher Campos Básicos
        if (lanc.descricao && document.getElementById('desc-sem-itens')) {
            document.getElementById('desc-sem-itens').value = lanc.descricao;
        }

        if (lanc.valor) {
            const valorFmt = parseFloat(lanc.valor).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
            const elValor = document.getElementById('valor-total-sem-itens');
            if (elValor) elValor.value = 'R$ ' + valorFmt;

            const elTotalNota = document.getElementById('valor-total-nota');
            if (elTotalNota) elTotalNota.value = 'R$ ' + valorFmt;
        }

        if (lanc.status === 'Pago') {
            const chk = document.getElementById('check-pagar-agora');
            if (chk) {
                chk.checked = true;
                chk.dispatchEvent(new Event('change'));

                // Populate Date Logic
                setTimeout(() => {
                    const elDataPagto = document.getElementById('data-pagamento-real');
                    if (elDataPagto && lanc.data_pagamento) {
                        elDataPagto.value = lanc.data_pagamento.split('T')[0];
                    }
                }, 50);
            }

        } // End of if Pago

        // --- RESTRICTED EDIT MODE (GLOBAL) ---
        // User Request: "Todos devem ser bloqueados"
        if (!isReadOnly) {
            // Disable all inputs except Obs and File Uploads
            setTimeout(() => {
                const allInputs = form.querySelectorAll('input, select, textarea, button');
                allInputs.forEach(el => {
                    // Whitelist
                    if (el.id === 'obs-lancamento' ||
                        el.id === 'file-upload-input' ||
                        el.classList.contains('btn-remove-anexo') ||
                        el.id === 'btn-salvar-lancamento' ||
                        el.id === 'btn-cancelar' || // Allow Cancel
                        el.innerText.trim().toUpperCase() === 'CANCELAR' || // Allow Text-based Cancel
                        el.type === 'submit') {
                        return;
                    }

                    // Disable
                    el.disabled = true;
                    el.style.setProperty('opacity', '0.7', 'important');

                    if (el.tagName === 'INPUT' || el.tagName === 'SELECT' || el.tagName === 'TEXTAREA') {
                        el.style.setProperty('background-color', '#f9fafb', 'important');
                        el.style.setProperty('color', '#6b7280', 'important');
                        el.style.setProperty('cursor', 'not-allowed', 'important');
                        el.style.setProperty('pointer-events', 'none', 'important');
                    }
                });

                form.querySelectorAll('.custom-select-container').forEach(d => {
                    d.style.pointerEvents = 'none';
                    d.style.opacity = '0.6';
                });

            }, 800);

            // Style overrides
            const styleRestricted = document.createElement('style');
            styleRestricted.id = 'style-restricted-edit';
            styleRestricted.innerHTML = `
                .btn-remove-item, 
                .btn-quick-add-item,
                .rateio-remove-btn,
                #btn-add-item,
                #btn-add-novo-parceiro,
                #btn-gerar-parcelas,
                .btn-add-safra-global,
                .item-remove-btn,
                .btn-add-maquina-custo,
                .btn-add-item-safra { display: none !important; }
                
                #detalhes-vista, #container-data-pagamento, #items-container, #area-rateio, #area-rateio-maquinas 
                { opacity: 0.95; pointer-events: none; }
                
                .form-group-obs { border: 1px dashed #4f46e5; padding: 10px; border-radius: 6px; background: #fffcf5; }
                .form-group-obs label { color: #4f46e5; font-weight: bold; }
                #lista-anexos { border: 1px dashed #4f46e5; padding: 10px; border-radius: 6px; background: #fffcf5; }
            `;
            document.head.appendChild(styleRestricted);

            const btnSalvar = document.getElementById('btn-salvar-lancamento');
            if (btnSalvar) {
                btnSalvar.disabled = false;
                btnSalvar.innerHTML = '<i class="fas fa-lock"></i> Salvar Somente Anexos/Obs';
                btnSalvar.classList.remove('btn-primary');
                btnSalvar.classList.add('btn-warning');
                btnSalvar.style.setProperty('pointer-events', 'auto', 'important');
            }
        } else {
            // Cleanup if needed (though isReadOnly logic at top usually handles cleanup via standard mode)
            // But if we toggle back and forth without reload?
            const existingRestricted = document.getElementById('style-restricted-edit');
            if (existingRestricted) existingRestricted.remove();

            const btnSalvar = document.getElementById('btn-salvar-lancamento');
            if (btnSalvar) {
                btnSalvar.innerHTML = 'Salvar Lançamento';
                btnSalvar.classList.add('btn-primary');
                btnSalvar.classList.remove('btn-warning');
            }
        }

        if (lanc.detalhes?.tipo_doc) document.getElementById('tipo-documento').value = lanc.detalhes.tipo_doc;
        if (lanc.detalhes?.num_doc) document.getElementById('num-documento').value = lanc.detalhes.num_doc;
        if (lanc.num_doc) document.getElementById('num-documento').value = lanc.num_doc; // Root override
        if (lanc.data_emissao) document.getElementById('data-emissao').value = lanc.data_emissao;
        if (lanc.data_vencimento) document.getElementById('data-vencimento').value = lanc.data_vencimento.split('T')[0];

        // --- ASYNC DEPENDENCY LOADERS ---
        const waitForParceiros = async () => {
            // ... existing wait logic if needed, simplified for brevity ...
            // Reusing previous safe implementation logic or trusting global data
            let attempts = 0;
            while (attempts < 25) {
                const sel = document.getElementById('parceiro-select');
                if (sel && sel.options.length > 1) return true;
                if (window.FazendaRP.Pages.financeiro.updateParceirosSelect && attempts === 0) await window.FazendaRP.Pages.financeiro.updateParceirosSelect(document);
                await new Promise(r => setTimeout(r, 200));
                attempts++;
            }
            return false;
        };

        if (lanc.parceiro_id) {
            await waitForParceiros();
            const selParceiro = document.getElementById('parceiro-select');
            if (selParceiro) {
                selParceiro.value = lanc.parceiro_id;
                if (selParceiro.value != lanc.parceiro_id) {
                    // Force Add option
                    const opt = document.createElement('option');
                    opt.value = lanc.parceiro_id;
                    opt.text = (lanc.parceiros ? lanc.parceiros.nome : "Parceiro " + lanc.parceiro_id);
                    selParceiro.add(opt);
                    selParceiro.value = lanc.parceiro_id;
                }
            }
        }

        // Categoria (Simple Mode)
        if (lanc.categoria) {
            const elCat = document.getElementById('categoria-contabil');
            if (elCat) elCat.value = lanc.categoria;

            // Populate Visible Search Input
            const elSearch = document.getElementById('categoria-search');

            if (elSearch) {
                // Ensure data is loaded
                if (!window.FazendaRP.Pages.financeiro.planoContasData) {
                    await window.FazendaRP.Pages.financeiro.loadPlanoContasData();
                }
                const accounts = window.FazendaRP.Pages.financeiro.planoContasData || [];
                // lanc.categoria is usually the code string "2.1.3"
                const savedCode = String(lanc.categoria).trim();

                // Try multiple match strategies
                const found = accounts.find(c =>
                    c.codigo == savedCode ||
                    `${c.codigo} - ${c.nome}` === savedCode ||
                    savedCode.startsWith(`${c.codigo} -`)
                );

                if (found) {
                    elSearch.value = `${found.codigo} - ${found.nome}`;
                } else {
                    elSearch.value = savedCode; // Fallback
                }

                // FORCE UPDATE UI if needed (sometimes value doesn't stick if element is hidden/detached)
                elSearch.setAttribute('value', elSearch.value);
            }
        }

        // --- GLOBAL RATEIO RESTORATION (Sem Itens) ---
        const globalRateio = lanc.detalhes ? lanc.detalhes.rateio : null;
        if (globalRateio && Array.isArray(globalRateio) && globalRateio.length > 0) {

            // Ensure UI is initialized
            const container = document.getElementById('financeiro-content') || document.getElementById('financeiro-content-area');
            if (window.FazendaRP.Pages.financeiro.setupGlobalRateio) {
                window.FazendaRP.Pages.financeiro.setupGlobalRateio(container);
            }

            // Ensure Safras Data
            if (!window.FazendaRP.Pages.financeiro.safrasCache || window.FazendaRP.Pages.financeiro.safrasCache.length === 0) {
                if (window.FazendaRP.Pages.financeiro.loadSafrasData) {
                    await window.FazendaRP.Pages.financeiro.loadSafrasData();
                }
            }

            // Populate
            const area = document.getElementById('area-rateio');
            // Give a small delay for UI to render if needed, though setupGlobalRateio is sync usually
            // However, setupGlobalRateio sets innerHTML which is sync.
            const btnAdd = area ? area.querySelector('.btn-add-safra-global') : null;
            const rowsContainer = area ? area.querySelector('.rateio-rows-area') : null;

            if (btnAdd && rowsContainer) {
                rowsContainer.innerHTML = ''; // Clear default auto-added row
                globalRateio.forEach(r => {
                    btnAdd.click();
                    const newRow = rowsContainer.lastElementChild;
                    if (newRow) {
                        const sSel = newRow.querySelector('.safra-select');
                        const sVal = newRow.querySelector('.safra-valor');
                        if (sSel) sSel.value = r.safra_id;
                        if (sVal) {
                            sVal.value = (r.valor || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
                            sVal.dispatchEvent(new Event('input'));
                        }
                    }
                });
            }
        }

        // Forma Pagamento
        if (lanc.conta_id) {
            const elConta = document.getElementById('conta-banco');
            if (elConta) {
                elConta.value = lanc.conta_id;
                // Dispatch change to trigger UI logic (e.g. Credit Card lock)
                elConta.dispatchEvent(new Event('change'));
            }
        }

        if (lanc.detalhes?.forma_pagamento || lanc.detalhes?.condicao) {
            const elCond = document.getElementById('condicao-pagamento');
            if (elCond && lanc.detalhes.condicao) {
                elCond.value = lanc.detalhes.condicao;
                elCond.dispatchEvent(new Event('change'));
            }
            setTimeout(() => {
                const elForma = document.getElementById('forma-pagamento');
                if (elForma && lanc.detalhes.forma_pagamento) {
                    elForma.value = lanc.detalhes.forma_pagamento;
                    // If Credit Card, ensure visual lock is applied again (though dispatchEvent above handled it, timing might differ)
                    if (lanc.detalhes.forma_pagamento === 'Cartão de Crédito') {
                        elForma.style.pointerEvents = 'none';
                        elForma.style.background = '#eee';
                    }
                }
            }, 500);
        }

        // --- MACHINE COST RESTORATION (Sem Itens) ---
        if (lanc.detalhes && lanc.detalhes.custo_maquinas && lanc.detalhes.custo_maquinas.length > 0) {
            const areaM = form.querySelector('#area-rateio-maquinas');
            // Ensure Setup
            if (window.FazendaRP.Pages.financeiro.setupMachineRateio) {
                window.FazendaRP.Pages.financeiro.setupMachineRateio(form);
            }

            const btnAddM = areaM ? areaM.querySelector('.btn-add-maquina-custo') : null;
            const rowsMContainer = areaM ? areaM.querySelector('.rateio-maquinas-rows-area') : null;

            if (btnAddM && rowsMContainer) {
                rowsMContainer.innerHTML = '';
                lanc.detalhes.custo_maquinas.forEach(c => {
                    btnAddM.click();
                    const newRow = rowsMContainer.lastElementChild;
                    if (newRow) {
                        const sel = newRow.querySelector('.maquina-select');
                        const val = newRow.querySelector('.maquina-valor');
                        if (sel) sel.value = c.maquina_id;
                        if (val) {
                            val.value = (c.valor || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
                        }
                        const lit = newRow.querySelector('.maquina-litros');
                        if (lit && c.litros) lit.value = c.litros;
                    }
                });
            }
        }

        // --- ITEMS HANDLING (FIX) ---
        const savedItems = lanc.detalhes ? lanc.detalhes.itens : null;
        const savedMode = lanc.detalhes ? lanc.detalhes.modo : null;

        if (savedMode === 'com_itens' || (savedItems && savedItems.length > 0)) {
            // 1. Switch Mode
            const radioComItens = document.querySelector('input[name="modo_lancamento"][value="com_itens"]');
            if (radioComItens) {
                radioComItens.checked = true;
                radioComItens.dispatchEvent(new Event('change')); // Trigger layout change
            }

            // 2. Populate Rows
            if (savedItems && Array.isArray(savedItems)) {
                // Wait for layout to render (microtask)
                setTimeout(() => {
                    const itemsContainer = document.getElementById('items-container');
                    if (!itemsContainer) return;
                    itemsContainer.innerHTML = ''; // Clear default empty row

                    savedItems.forEach(item => {
                        // Create Row
                        const div = document.createElement('div');
                        if (window.FazendaRP.Pages.financeiro.getItemRowHTML) {
                            div.innerHTML = window.FazendaRP.Pages.financeiro.getItemRowHTML();
                            const row = div.firstElementChild;
                            itemsContainer.appendChild(row);

                            // Populate Fields
                            const inpMat = row.querySelector('.item-material-search');
                            if (inpMat) inpMat.value = item.nome || '';

                            // 2. Setup Events (Critical for Dropdowns)
                            if (window.FazendaRP.Pages.financeiro.setupMaterialDropdown) {
                                window.FazendaRP.Pages.financeiro.setupMaterialDropdown(row);
                            }
                            if (window.FazendaRP.Pages.financeiro.setupItemRateioEvents) {
                                window.FazendaRP.Pages.financeiro.setupItemRateioEvents(row);
                            }

                            // 3. Populate Machine (Critical Fix)
                            if (item.maquina_id) {
                                const machineArea = row.querySelector('.item-machine-area');
                                if (machineArea) {
                                    machineArea.style.display = 'flex';
                                    const sel = machineArea.querySelector('.item-maquina-select');
                                    // Ensure method exists
                                    if (sel && window.FazendaRP.Pages.financeiro.populateMachineSelect) {
                                        window.FazendaRP.Pages.financeiro.populateMachineSelect(sel);
                                        sel.value = item.maquina_id;
                                    }
                                    const hor = row.querySelector('.item-horimetro');
                                    if (hor && item.horimetro) hor.value = item.horimetro;
                                }
                            }

                            // 4. Populate Account Select
                            const accSel = row.querySelector('.item-plano-select');
                            if (accSel && window.FazendaRP.Pages.financeiro.populateAccountSelect) {
                                window.FazendaRP.Pages.financeiro.populateAccountSelect(accSel);
                                if (item.categoria) accSel.value = item.categoria;
                            }

                            // Qtd
                            const inpQtd = row.querySelector('.item-qtd');
                            const qtdVal = item.qtd || 1;
                            if (inpQtd) inpQtd.value = parseFloat(qtdVal).toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 });

                            // Unit Discount (Restore)
                            const unitDiscount = item.desconto_unit || 0;
                            const inpDesc = row.querySelector('.item-desc');
                            if (inpDesc) inpDesc.value = unitDiscount > 0 ? unitDiscount.toLocaleString('pt-BR', { minimumFractionDigits: 4 }) : '';

                            // Total (Net)
                            const totalVal = item.total || 0;
                            const inpTotal = row.querySelector('.item-total');
                            if (inpTotal) inpTotal.value = totalVal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

                            // V Unit (Gross = Net Unit + Discount)
                            const netUnit = totalVal / qtdVal;
                            // Prefer explicit saved Gross Unit, otherwise back-calculate
                            const grossUnit = item.valor_unitario || (netUnit + unitDiscount);

                            const inpVUnit = row.querySelector('.item-vunit');
                            if (inpVUnit) inpVUnit.value = grossUnit.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 4 });

                            // Account (Category)
                            const selCat = row.querySelector('.item-plano-select');
                            if (selCat) {
                                if (window.FazendaRP.Pages.financeiro.populateAccountSelect) {
                                    window.FazendaRP.Pages.financeiro.populateAccountSelect(selCat);
                                }
                                selCat.value = item.categoria;
                            }

                            // Machine
                            if (item.maquina_id) {
                                const machineArea = row.querySelector('.item-machine-area');
                                if (machineArea) {
                                    machineArea.style.display = 'flex'; // Force show
                                    const selMaq = row.querySelector('.item-maquina-select');
                                    if (window.FazendaRP.Pages.financeiro.populateMachineSelect) {
                                        window.FazendaRP.Pages.financeiro.populateMachineSelect(selMaq);
                                    }
                                    if (selMaq) selMaq.value = item.maquina_id;

                                    // Horimeter
                                    const inpHor = row.querySelector('.item-horimetro');
                                    if (inpHor && item.horimetro) {
                                        inpHor.value = item.horimetro;
                                        inpHor.style.display = 'block';
                                        selMaq.dispatchEvent(new Event('change'));
                                    }
                                }
                            }

                            // Initialize Dropdown Logic
                            if (window.FazendaRP.Pages.financeiro.setupMaterialDropdown) {
                                window.FazendaRP.Pages.financeiro.setupMaterialDropdown(row);
                            }

                            // Setup Masks
                            if (window.jQuery && window.jQuery.fn.mask) {
                                window.jQuery(row).find('.decimal-mask').mask("#.##0,000", { reverse: true });
                            }

                            // --- Rateio Restoration Logic ---
                            if (window.FazendaRP.Pages.financeiro.setupItemRateioEvents) {
                                window.FazendaRP.Pages.financeiro.setupItemRateioEvents(row);
                            }

                            // Trigger Visibility Check
                            if (selCat) selCat.dispatchEvent(new Event('change'));

                            // Restore Saved Rateio Rows
                            if (item.rateio && Array.isArray(item.rateio) && item.rateio.length > 0) {
                                const restoreSafras = async () => {
                                    // Ensure Safras Data is Loaded
                                    if (!window.FazendaRP.Pages.financeiro.safrasCache || window.FazendaRP.Pages.financeiro.safrasCache.length === 0) {
                                        if (window.FazendaRP.Pages.financeiro.loadSafrasData) {
                                            await window.FazendaRP.Pages.financeiro.loadSafrasData();
                                        }
                                    }

                                    const btnAddSafra = row.querySelector('.btn-add-item-safra');
                                    const rowsArea = row.querySelector('.item-rateio-rows');

                                    if (btnAddSafra && rowsArea) {
                                        rowsArea.innerHTML = '';

                                        item.rateio.forEach(r => {
                                            btnAddSafra.click(); // This adds the DOM with <select> populated from cache
                                            const newRow = rowsArea.lastElementChild;
                                            if (newRow) {
                                                const sSel = newRow.querySelector('.safra-select');
                                                const sVal = newRow.querySelector('.safra-valor');
                                                if (sSel) {
                                                    sSel.value = r.safra_id;
                                                }
                                                if (sVal) {
                                                    sVal.value = (r.valor || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
                                                    sVal.dispatchEvent(new Event('input'));
                                                }
                                            }
                                        });
                                    }
                                };
                                restoreSafras();
                            }
                        }
                    });

                    // Update Total Footer
                    if (window.FazendaRP.Pages.financeiro.updateItensTotal) {
                        window.FazendaRP.Pages.financeiro.updateItensTotal(itemsContainer);
                    }

                }, 100);
            }
        }

        // --- ATTACHMENTS RESTORATION ---
        if (lanc.anexos && Array.isArray(lanc.anexos) && lanc.anexos.length > 0) {

            // 1. Populate State
            window.FazendaRP.Pages.financeiro.currentAttachments = [...lanc.anexos];

            // 2. Render UI
            const attachContainer = document.getElementById('lista-anexos');
            if (attachContainer) {
                attachContainer.innerHTML = '';

                lanc.anexos.forEach(att => {
                    const div = document.createElement('div');
                    div.className = 'anexo-item';
                    div.style.cssText = "display: flex; align-items: center; justify-content: space-between; background: #fff; padding: 10px; border: 1px solid #eee; border-radius: 6px; font-size: 0.9rem;";

                    div.innerHTML = `
                        <div style="display:flex; align-items:center; gap:10px;">
                            <i class="fas fa-check-circle" style="color:green"></i>
                            <a href="${att.url}" target="_blank" style="text-decoration:none; color:#333; font-weight:500;">${att.name}</a>
                        </div>
                         <button type="button" class="btn-remove-anexo" style="border:none; background:none; color:red; cursor:pointer;" title="Remover"><i class="fas fa-times"></i></button>
                    `;

                    // Bind Remove Logic
                    const btnRemove = div.querySelector('.btn-remove-anexo');
                    if (btnRemove) {
                        if (isReadOnly) {
                            btnRemove.style.display = 'none';
                        } else {
                            btnRemove.onclick = () => {
                                // Remove from State
                                const currentArr = window.FazendaRP.Pages.financeiro.currentAttachments;
                                if (currentArr) {
                                    window.FazendaRP.Pages.financeiro.currentAttachments = currentArr.filter(a => a.path !== att.path);
                                }
                                // Remove from DOM
                                div.remove();
                            };
                        }
                    }

                    attachContainer.appendChild(div);
                });
            }
        } else {
            // Reset State if empty
            window.FazendaRP.Pages.financeiro.currentAttachments = [];
            const attachContainer = document.getElementById('lista-anexos');
            if (attachContainer) attachContainer.innerHTML = '';
        }
    },

    // --- HELPERS ---

    /**
     * Deleta lançamento e realiza o "WIPE TOTAL" (Limpeza Completa)
     * 1. Limpa Abastecimentos (Máquinas)
     * 2. Limpa Pagamentos (Financeiro)
     * 3. Limpa Estoque e Recalcula (Suprimentos)
     * 4. Deleta Lançamento Pai
     */
    deletarLancamentoCompleto: async function (lancamentoId) {
        console.log(`🚀 [WIPE] Iniciando limpeza total do lançamento: ${lancamentoId}`);

        try {
            // 1. LIMPAR ABASTECIMENTOS (Máquinas)
            console.log(`🚜 [WIPE] Verificando vínculos com Máquinas...`);
            const { error: errMaq } = await window.FazendaRP.supabase
                .from('maquinas_abastecimentos')
                .delete()
                .eq('lancamento_id', lancamentoId);

            if (errMaq) {
                console.warn("⚠️ [WIPE] Erro ao limpar abastecimentos:", errMaq);
            } else {
                console.log("✅ [WIPE] Abastecimentos limpos com sucesso.");
            }

            // 2. LIMPAR ESTOQUE (Suprimentos)
            console.log(`📦 [WIPE] Verificando movimentações de estoque vinculadas...`);
            let recalculados = 0;
            let movsDeletadas = 0;

            if (window.FazendaRP.Estoque?.deletarMovimentacaoPorOrigem) {
                // Tenta apagar como COMPRA (Entrada) ou APLICACAO (Saída DIRETA)
                // O Ideal seria buscar as movs antes para saber os estoque_ids, 
                // mas deletarMovimentacaoPorOrigem já faz isso internamente.
                try {
                    const resCompra = await window.FazendaRP.Estoque.deletarMovimentacaoPorOrigem('COMPRA', lancamentoId);
                    const resAplic = await window.FazendaRP.Estoque.deletarMovimentacaoPorOrigem('APLICACAO', lancamentoId);

                    movsDeletadas = (resCompra.count || 0) + (resAplic.count || 0);
                    console.log(`✅ [WIPE] ${movsDeletadas} movimentações de estoque removidas.`);
                } catch (e) {
                    console.error("❌ [WIPE] Erro ao limpar estoque via API:", e);
                }
            } else {
                console.warn("⚠️ [WIPE] API de Estoque não disponível para limpeza automática.");
            }

            // 4. DELETAR LANÇAMENTO PAI
            console.log(`🗑️ [WIPE] Removendo registro do lançamento principal...`);
            const { error: delLancErr } = await window.FazendaRP.supabase
                .from('financeiro_lancamentos')
                .delete()
                .eq('id', lancamentoId);

            if (delLancErr) throw delLancErr;

            console.log(`✨ [WIPE] CONCLUSÃO: Lançamento ${lancamentoId} e todos os seus rastros foram eliminados.`);

            return {
                success: true,
                movimentacoesDeletadas: movsDeletadas
            };

        } catch (error) {
            console.error('❌ [WIPE] ERRO CRÍTICO na limpeza total:', error);
            throw error;
        }
    },


    _registrarMovimentacaoEstoqueDireto: async function (params) {
        // params: { itemNome, itemId (opt), tipo: 'ENTRADA'|'SAIDA', quantidade, custoUnitario (opt), origemTipo, origemId, observacao, unidade, date }
        console.log("Gestionando Estoque Direto:", params);

        try {
            const { itemNome, itemId, tipo, quantidade, custoUnitario, origemTipo, origemId, observacao, unidade, date } = params;

            // 1. Buscar ou Criar Estoque
            let estoqueId = null;
            let currentSaldo = 0;
            let currentCusto = 0;
            let itemNomeFinal = itemNome; // ✅ Will use DB name if found

            // Tenta buscar por ID primeiro, depois por Nome (CASE-INSENSITIVE)
            let query = window.FazendaRP.supabase.from('suprimentos_estoque').select('*');
            if (itemId) query = query.eq('item_id', itemId);
            else query = query.ilike('item_nome', itemNome); // ✅ FIX: Case-insensitive search

            const { data: est, error: findErr } = await query.maybeSingle();

            if (findErr) { console.error("Erro busca estoque:", findErr); return; }

            if (est) {
                estoqueId = est.id;
                currentSaldo = parseFloat(est.saldo_atual || 0);
                currentCusto = parseFloat(est.custo_medio || 0);
                itemNomeFinal = est.item_nome; // ✅ USE EXACT NAME FROM DB
                console.log(`[STOCK] Found existing: "${itemNome}" → Using DB name: "${itemNomeFinal}"`);
            } else {
                // Criar novo se for ENTRADA
                if (tipo !== 'ENTRADA') {
                    console.warn("Tentativa de SAIDA de item inexistente no estoque:", itemNome);
                    return; // Can't exit what doesn't exist
                }

                itemNomeFinal = itemNome; // Use normalized name for new items

                const { data: newEst, error: createErr } = await window.FazendaRP.supabase
                    .from('suprimentos_estoque')
                    .insert([{
                        item_id: itemId || null,
                        item_nome: itemNomeFinal,
                        unidade: unidade || 'UN',
                        saldo_atual: 0,
                        custo_medio: custoUnitario || 0
                    }])
                    .select()
                    .single();

                if (createErr) { console.error("Erro criar estoque:", createErr); return; }
                estoqueId = newEst.id;
                console.log(`[STOCK] Created new: "${itemNomeFinal}"`);
            }

            // 2. Calcular Novo Saldo e Custo Médio
            let newSaldo = currentSaldo;
            let newCusto = currentCusto;

            if (tipo === 'ENTRADA') {
                const qtdIn = parseFloat(quantidade);
                const custoIn = parseFloat(custoUnitario);

                const valorAtual = currentSaldo * currentCusto;
                const valorEntrada = qtdIn * custoIn;

                newSaldo = currentSaldo + qtdIn;
                if (newSaldo > 0) {
                    newCusto = (valorAtual + valorEntrada) / newSaldo;
                }
            } else if (tipo === 'SAIDA') {
                newSaldo = currentSaldo - parseFloat(quantidade);
                // Custo médio não muda na saída
            }

            // 3. Atualizar Estoque
            await window.FazendaRP.supabase
                .from('suprimentos_estoque')
                .update({ saldo_atual: newSaldo, custo_medio: newCusto, updated_at: new Date() })
                .eq('id', estoqueId);

            // 4. Registrar Movimentação
            await window.FazendaRP.supabase.from('suprimentos_movimentacoes').insert([{
                estoque_id: estoqueId,
                tipo: tipo,
                quantidade: parseFloat(quantidade),
                origem_tipo: origemTipo,
                origem_id: /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(origemId) ? origemId : null,
                observacao: observacao + (/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(origemId) ? '' : ` (Ref ID: ${origemId})`),
                custo_unitario: parseFloat(custoUnitario || 0), // ✅ SNAPSHOT: Preço unitário
                valor_total: parseFloat(quantidade) * parseFloat(custoUnitario || 0), // ✅ SNAPSHOT: Valor total
                data_movimentacao: date || new Date().toISOString().split('T')[0],  // ✅ FIX: Use correct column name
                created_at: new Date().toISOString()
            }]);

            console.log("Estoque Atualizado com Sucesso (Direto).");

            // --- AUTO-CORRECTION FOR BACKDATED/OUT-OF-ORDER ENTRIES ---
            // If the user inserts a transaction, we trigger a recalculation to fix any historical cost distortions.
            if (window.FazendaRP.Pages.suprimentos && window.FazendaRP.Pages.suprimentos.migration && window.FazendaRP.Pages.suprimentos.migration.recalculateItem) {
                // Ensure slight delay to allow DB propagation if needed, although await above should suffice.
                // We use setTimeout to not block the UI response (Fire and Forget)
                setTimeout(() => {
                    console.log(`Triggering Auto-Recalc for Item: ${itemNome}`);
                    window.FazendaRP.Pages.suprimentos.migration.recalculateItem(itemNome, itemId, estoqueId);
                }, 500);
            }

        } catch (e) {
            console.error("Erro crítico em _registrarMovimentacaoEstoqueDireto:", e);
        }
    }

});
